import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import VueTilt from "vue-tilt.js";
import VueSweetalert2 from "vue-sweetalert2";
import ArgonDashboard from "./argon-dashboard";
import { initialize } from './helpers/general'
import Toast from "vue-toastification";
import VCalendar from 'v-calendar';
import PrimeVue from 'primevue/config';
import ConfirmationService from 'primevue/confirmationservice';
import Maska from 'maska'

import "vue-toastification/dist/index.css";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import 'v-calendar/style.css';
import 'primevue/resources/themes/aura-light-green/theme.css'
import './registerServiceWorker'

const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(Maska);
appInstance.use(Toast);
appInstance.use(router);
appInstance.use(VueTilt);
appInstance.use(VueSweetalert2);
appInstance.use(ArgonDashboard);
appInstance.use(VCalendar);
appInstance.use(PrimeVue);
appInstance.use(ConfirmationService);

initialize(store, router)

appInstance.mount("#app");
